module.exports = __webpack_public_path__ + "assets/img/login.fa430498.png";